import type { RouterConfig } from '@nuxt/schema';

export default <RouterConfig>{
	routes: routes => [
		...routes,
		{
			name: 'category-short-main',
			path: '/c/:productnature?',
			component: () => import('~/components/category/MainCategoryPage.vue'),
		},
		{
			name: 'category-short-company',
			path: '/:companyId/c/:productnature?',
			component: () => import('~/components/category/SubCategoryPage.vue'),
		},
		{
			name: 'category-short-detail-main',
			path: '/c-:categoryId',
			component: () => import('~/pages/[companyId]/categoryList/[[productnature]]/index.vue'),
		},
		{
			name: 'category-short-detail-company',
			path: '/:companyId/c-:categoryId',
			component: () => import('~/pages/[companyId]/categoryList/[[productnature]]/index.vue'),
		},
		{
			name: 'company-certification-html',
			path: '/:companyId/certification.html',
			component: () => import('~/pages/[companyId]/certification/index.vue'),
		},
	],
};
